<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 checklistTempTab"
                        :data="detailTabs"
                        activeKey="basic_info">
                    <template slot="gofixTab:right">
                        <gofix-button v-if="this.user.id != 0"
                            :loading="disabled"
                            :disabled="$disabledCreateOrUpdate(this.user, $accessModule.users)"
                            label="Save"
                            @click="save"></gofix-button>
                        <gofix-button v-if="this.user.id == 0"
                            :loading="disabled"
                            :disabled="$disabledCreateOrUpdate(this.user, $accessModule.users)"
                            label="Save"
                            @click="check_save"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic_info">
                        <b-form autocomplete="off">
                            <gofix-card classContent="mb-0">
                                <b-row class="mt-4" v-if="userType === 'tenant'">
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            label="Client Contract"
                                            vLabel="contract_name"
                                            :filterable="true"
                                            :required="true"
                                            v-model="$v.user.contract_id.$model"
                                            :reduce="option => option.id"
                                            :options="client_contracts">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-properties
                                            label="Property"
                                            :contract-id="user.contract_id"
                                            v-model="$v.user.property.$model"
                                            valueFormat="object"
                                            required>
                                        </gofix-form-properties>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4" v-else>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            label="Company"
                                            vLabel="name"
                                            @search="searchOrganization"
                                            :filterable="false"
                                            v-model="$v.user.organization.$model"
                                            :options="organizations"
                                            :clearable="false"
                                            required>
                                            <template  #gofixInput:dropdown:no-options>
                                                Please enter to search organization!
                                            </template>
                                            <template #gofixInput:dropdown:option="{name}">
                                                <span class="color-000">{{ name }}</span>
                                            </template>
                                            <template #gofixInput:dropdown:selected-option="{name}">
                                                <span class="color-000">{{ name }}</span>
                                            </template>
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <b-form-checkbox v-model="user.active" class="ml-16 mt-30"><span class="ml-2">Disabled</span></b-form-checkbox>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field class="ml-16 mt-30" label="MS OTP Authentication" oneline>
                                            <b-form-checkbox :disabled="!$checkRole($accessModule.allow_modifying_other_user_mfa, 'allow_modifying_other_user_mfa')" :value="true" v-model="user.microsoft2fa_enable" :unchecked-value="false" switch>
                                            </b-form-checkbox>
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card>
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-form-input label="User Name" v-model="$v.user.name.$model" autocomplete="off" required></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input required label="Department" v-model="user.department" autocomplete="off"></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input label="Designation" v-model="user.designation" autocomplete="off"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            label="Role"
                                            vLabel="name"
                                            :filterable="true"
                                            :multiple="true"
                                            :required="true"
                                            v-model="user.role"
                                            :options="RoleItems.data">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            label="GOfix Project"
                                            vLabel="reference_value_text"
                                            :filterable="true"
                                            :multiple="true"
                                            required
                                            show-icon-required
                                            v-model="$v.user.gofix_projects.$model"
                                            :options="gofixProjects">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input label="Email" type="email" v-model="$v.user.email.$model" autocomplete="off" required :disabled="!$route.path.includes('add')"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-input label="Password" type="password" v-model="$v.user.password.$model" autocomplete="new-password" :required="$route.path.includes('add')">
                                            <template slot="gofixInput:text:after-desc">
                                                <p class="desc">
                                                    <small v-if="$v.user.repassword.$error" class="clear-small label-error">Password doesn’t match</small>
                                                    <!--<small v-if="!$v.user.repassword.$error && !$v.user.password.minLength" class="clear-small label-error">Minimum 8 characters</small>-->
                                                </p>
                                            </template>
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input label="Confirm Password" type="password" v-model="$v.user.repassword.$model" autocomplete="new-password" :required="$route.path.includes('add')">
                                            <template slot="gofixInput:text:after-desc">
                                                <p class="desc">
                                                    <small v-if="$v.user.repassword.$error" class="clear-small label-error">Password doesn’t match</small>
                                                    <!--<small v-if="!$v.user.repassword.$error && !$v.user.password.minLength" class="clear-small label-error">Minimum 8 characters</small>-->
                                                </p>
                                            </template>
                                        </gofix-form-input>
                                    </b-col>
                                     <b-col md="2">
                                        <gofix-form-input
                                            :value="user.email_verified_at | formatDatebyMoment('YYYY-MM-DD HH:mm:ss','DD.MM.YYYY HH:mm')"
                                            desc="dd.mm.yyyy hh:mm"
                                            label="Email verified at"
                                            disabled>
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-dropdown
                                            label="Preferred Mode of Contact"
                                            :clearable="false"
                                            vLabel="reference_value_text"
                                            :reduce="option => option.reference_value_text"
                                            :filterable="false"
                                            :required="true"
                                            v-model="user.preferred_contact_mode"
                                            :disable-capitalize-label="true"
                                            :options="preferred_mode">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4" class="custom-cases gofixLogoContract gofixSignature">
                                        <gofix-text-field label="Signature" class="editPhotoValue" classLabel="font-14" classValue="pl-0" classInner="d-block" oneline>
                                            <div class="d-flex align-items-center viewer mt-11">
                                                <template v-if="user.signature_image">
                                                    <viewer-image :images="user.signature_image" classViewer='d-flex align-items-center'>
                                                        <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                            <ul class="list-thumb list-unstyled max-width-per-100 mb-0">
                                                                <li class="mb-0 mr-10" v-for="(item, key) in images" v-bind:key="key">
                                                                    <img v-auth-image="item.url.original" :alt="item.image_file_name || 'image'"  src="img/loading.gif">
                                                                </li>
                                                            </ul>
                                                        </template>    
                                                    </viewer-image>
                                                </template>
                                                <div class="upload-btn-wrapper m-0">
                                                    <b-form-file v-model="attachmentFile" accept=".jpg, .png, .gif" plain></b-form-file>
                                                    <gofix-button :label="!user.signature_image || !user.signature_image.length ? 'ADD PHOTO' : 'CHANGE PHOTO'" outline></gofix-button>
                                                </div>
                                            </div>
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card v-if="!$route.path.includes('add')">
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-text-field classLabel="width-120" label="Login Count" oneline>{{ userDataRead.login_count ? userDataRead.login_count: 0 }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-text-field classLabel="width-120" label="Last Login At" oneline>{{ userDataRead.last_login ? userDataRead.last_login: null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-text-field classLabel="width-120" label="Created At" oneline>{{ userDataRead.created_at ? userDataRead.created_at: null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-text-field classLabel="width-120" label="Created By" oneline>{{ userDataRead.created_by_name }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-text-field classLabel="width-120" label="Last Updated At" oneline>{{ userDataRead.updated_at ? userDataRead.updated_at: null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-text-field classLabel="width-120" label="Updated By" oneline>{{ userDataRead.updated_by_name }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4" v-if="$route.params.user_id">
                                    <b-col md="12">
                                      <gofix-button label="See last 10 logins" @click="modals.last_login.open = true"></gofix-button>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <div>
                                <h3 class="gofixContentTitle">Address</h3>
                            </div>
                            <template v-for="(address,index) in user.address">
                                <gofix-card classContent="mb-0 position-relative" :key="index">
                                    <template slot="gofixCard:before_card_content">
                                        <button class="icon-button gofixIconButton gofixPositionTopRight position-absolute" @click="removeUserAddress(index)">
                                            <svg width="18" height="20" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 5H19" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5M17 5V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5H17Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8 10V16" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12 10V16" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </button>
                                    </template>
                                    <div class="pr-4">
                                        <b-row class="mt-4">
                                            <b-col md="4">
                                                <gofix-form-dropdown
                                                    label="Salutation"
                                                    vLabel="reference_value_text"
                                                    :filterable="false"
                                                    :required="user.mailing_address_id_tmp === index"
                                                    v-model="address.salutation"
                                                    :reduce="option => option.reference_value_text"
                                                    :options="salutations">
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input
                                                    :required="user.mailing_address_id_tmp === index"
                                                    label="First Name"
                                                    autocomplete="off"
                                                    v-model="address.first_name"></gofix-form-input>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input
                                                    :required="user.mailing_address_id_tmp === index"
                                                    label="Last Name"
                                                    autocomplete="off"
                                                    v-model="address.last_name"></gofix-form-input>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-text-field label="Address">
                                                    <template slot="gofixTextField:after_label">
                                                        <gofix-button class="editRight float-right" label="Edit" noBorder fontNormal small @click="openAddressModal(address,index)"></gofix-button>
                                                    </template>
                                                    {{address.display_address}}
                                                </gofix-text-field>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input-number
                                                    label="Mobile Phone"
                                                    v-model="address.primary_phone"
                                                    :integer-limit="15"
                                                    :include-thousands-separator="false"
                                                    :allowDecimal="false">
                                                </gofix-form-input-number>
                                            </b-col>
                                            <b-col md="4">
                                                <b-form-checkbox class="ml-16 mt-30" v-model="address.phone_verified"><span class="ml-2">Mobile Phone Verified</span></b-form-checkbox>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input-number
                                                    label="Second Phone"
                                                    v-model="address.secondary_phone"
                                                    :integer-limit="15"
                                                    :include-thousands-separator="false"
                                                    :allowDecimal="false">
                                                </gofix-form-input-number>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input
                                                    :required="user.mailing_address_id_tmp === index"
                                                    label="Email Address"
                                                    v-model="address.email"
                                                    type="email" autocomplete="off"></gofix-form-input>
                                            </b-col>
                                            <b-col md="4">
                                                <div class="d-flex justify-content-between">
                                                    <b-form-checkbox class="ml-16 mt-30" v-model="address.email_verified"><span class="ml-2">Email Verified</span></b-form-checkbox>
                                                    <b-form-checkbox class="ml-16 mt-30" v-model="user.mailing_address_id_tmp" :value="index"><span class="ml-2">Default Mailing</span></b-form-checkbox>
                                                    <b-form-checkbox class="ml-16 mt-30" v-model="user.billing_address_id_tmp" :value="index"><span class="ml-2">Default Billing</span></b-form-checkbox>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </gofix-card>
                            </template>
                            <div class="action">
                                <gofix-button label="Add Address" @click="addUserAddress" outline></gofix-button>
                            </div>
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Address" title="Address" hide-footer :centered="true" ref="modal-address">
            <b-form class="pb-10">
                <gofix-form-input label="Street Number" v-model="activeAddress.street_no"></gofix-form-input>
                <gofix-form-input label="Street Name" v-model="activeAddress.street_name"></gofix-form-input>
                <gofix-form-input label="Unit no" v-model="activeAddress.unit_no"></gofix-form-input>
                <gofix-form-input label="Building Name" v-model="activeAddress.building_name"></gofix-form-input>
                <gofix-form-input label="Country" v-model="activeAddress.country" disabled></gofix-form-input>
                <gofix-form-input label="Postal code" v-model="activeAddress.postal_code"></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="hanldeAddress" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create-Check-User" :title="modals.title" hide-footer :centered="true" v-model="modals.open" ref="modal-check">
            <b-form>
                <b-row>
                    <b-col md="12">
                        <p style="font-size: 14px; color: rgba(0, 0, 0, 0.6);">
                            Your email has already existed and being marked as disabled. Do you want:
                        </p>
                    </b-col>
                    <b-col md="12">
                        <gofix-button
                            label="Recover the existing account"
                            class="mr-3"
                            @click="save(2)"
                        ></gofix-button>
                        <gofix-button
                            label="Create a new account"
                            class="mr-3"
                            @click="save(3)"
                        ></gofix-button>
                        <gofix-button
                            label="Cancel"
                            @click="save(0)"
                        ></gofix-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
      <b-modal :no-close-on-backdrop="true" id="modal-Create-Check-User" :title="modals.last_login.title" hide-footer :centered="true" v-model="modals.last_login.open" ref="modal-check">
        <div class="pl-10 pr-10">
          <ul class="list-unstyled list-client" v-if="login_histories" v-bind:class="{'run-loading':modals.last_login.loading}">
            <template v-for="(item, index) in login_histories">
              <li v-bind:key="item.id">
                <p>
                  IP: {{ item.ip }}
                  <small>Login at: {{ item.login_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm:ss")}}</small>
                  <small>Logout at: {{ item.logout_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm:ss")}}</small>
                  <small>Bowse engine: {{ item.browse_engine}}</small>
                </p>
              </li>
            </template>
          </ul>
        </div>
      </b-modal>
        <b-toast id="toast-custom1" variant="danger" solid>
        <template #toast-title>
            <div class="d-flex flex-grow-1 align-items-baseline">
            <strong class="mr-auto">Notification</strong>
            </div>
        </template>
        <div class="err-pwd-toast" v-if="errorMessage">
            <div v-html="errorMessage"></div>
        </div>
        </b-toast>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { validationMixin } from 'vuelidate'
    import { required, email, sameAs, minLength ,requiredIf} from 'vuelidate/lib/validators'
    import { generalAddressFormat } from "./../../_commonVar.js";
    const ViewerImage = () => import('../plugins/ViewerImage.vue')
    
    export default {
        name: 'user-info',
        components: {
            ViewerImage
        },
        data () {
            return {
                userType: "fm-officer",
                detailTabs:[
                    {
                        key: "basic_info",
                        title: "basic info",
                        active: true,
                    },
                ],
                errorMessage:null,
                disabled: false,
                user: {
                    id: '',
                    name: '',
                    department: '',
                    designation:null,
                    organization: null,
                    email: '',
                    password: '',
                    repassword : '',
                    address: [],
                    primary_phone: '',
                    active: true,
                    role:[],
                    email_verified_at: null,
                    preferred_contact_mode: "Email",
                    mailing_address_id: null,
                    mailing_address_id_tmp: null,
                    billing_address_id: null,
                    billing_address_id_tmp: null,
                    contract_id: null,
                    property_id: null,
                    property: null,
                    microsoft2fa_enable:false,
                    gofix_projects: null
                },
                userDataRead: {
                    login_count: null,
                    last_login: null,
                    created_at: null,
                    created_by_name: null,
                    updated_at: null,
                    updated_by_name: null,
                },
                organizations : [],
                client_contracts : [],
                group_tags : "Client",
                modals:{
                    open:false,
                    loading:false,
                    title:"Create User",
                    restore_user_id:null,
                    last_login:{
                      open:false,
                      loading:false,
                      title:"Latest login",
                    }
                },
                activeAddress: {},
                salutations:[],
                preferred_mode:[],
                login_histories: [],
                attachmentFile: null,
                gofixProjects: []
            }
        },
        mixins: [validationMixin],
        validations: {
            user: {
                name: {
                    required
                },
                email: {
                    email,
                    required: requiredIf(function() {
                        return this.$route.path.includes('add');
                    })
                },
                password: {
                    //minLength: minLength(8),
                    required: requiredIf(function(){
                        return this.$route.path.includes('add')
                    })
                },
                repassword: {
                    sameAsPassword: sameAs("password"),
                    required: requiredIf(function() {
                        return this.$route.path.includes('add');
                    })
                },
                organization: {
                    required: requiredIf(function() {
                        return !this.$route.path.includes('tenant');
                    })
                },
                contract_id: {
                    required: requiredIf(function() {
                        return this.$route.path.includes('tenant');
                    })
                },
                property: {
                    required: requiredIf(function() {
                        return this.$route.path.includes('tenant');
                    })
                },
                gofix_projects: {
                    required
                }
            }
        },
        created () {
            this.setUserType();
            if(!this.$route.path.includes('add') && (!this.$route.params.hasOwnProperty('user_id') || isNaN(this.$route.params.user_id))) {
                return this.$router.push(this.$route.matched[this.$route.matched.length - 1].parent.path);
            }
            if(!this.$route.path.includes('add')) {
                this.$store.dispatch('v2UserController/getUser', this.$route.params.user_id)
                    .then(response => { this.setData(response.data.data) })
                    .catch(error => {})
            }
            this.organizations = this.Organizations
            if(this.Organizations.length === 0) {
                this.$store.dispatch( 'OrganizationController/searchItemsInUser', {page: 1, filter: {}, limit: 100 })
                    .then(response => { this.organizations = response.data.data.items; })
                    .catch(err=> {})
            }

            if(this.user.organization){
                if(this.user.organization.is_fm_company){
                    this.group_tags = "FM";
                }
                if(this.user.organization.is_supplier){
                    this.group_tags = "Supplier";
                }
            }else{
                this.group_tags = "Tenant";
                if(this.$route.path.includes('supplier')) {
                    this.group_tags = "Supplier";
                }
                if(this.$route.path.includes('fm-officer')) {
                    this.group_tags = "FM";
                }
                if(this.$route.path.includes('client')) {
                    this.group_tags = "Client";
                }
                
            }

            let params = {
                filter: {
                    group_tags : this.group_tags
                }
            }
            if(this.group_tags == 'FM') {
                params.allow_roles = ['Project Manager']
            }

            this.$store.dispatch("RoleController/getRoleItems",params);
            this.getSalutations();
            this.getPreferredMode();
            this.loadLoginHistories();
            this.getPreferredGofixProjects();
        },
        watch:{
            "user.organization" : function(val,old){
                if(val){
                    this.group_tags = "Client";
                    if(val.is_fm_company){
                        this.group_tags = "FM";
                    }
                    if(val.is_supplier){
                        this.group_tags = "Supplier";
                    }

                    let params = {
                        filter: {
                            group_tags : this.group_tags
                        }
                    }
                    if(this.group_tags == 'FM') {
                        params.allow_roles = ['Project Manager']
                    }

                    this.$store.dispatch("RoleController/getRoleItems",params);
                }
            },
            "attachmentFile": function (val) {
                if (val) {
                    if (val.type !== 'image/jpeg' && val.type !== 'image/png' && val.type !== 'image/gif') {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }

                    var _this = this;
                    const img = new Image();
                    img.src = URL.createObjectURL(val);

                    let data = {
                        url: {
                            original: URL.createObjectURL(val),
                            medium: URL.createObjectURL(val),
                            thumb: URL.createObjectURL(val)
                        }
                    };
                    
                    if(!this.user.signature_image || !this.user.signature_image.length)
                        this.user.signature_image = [data]
                    else
                        this.user.signature_image[0].url = data.url;
                }
            },
        },
        computed: {
            ...mapGetters({
                Items: 'v2UserController/ListingUser',
                IteamUser: 'v2UserController/IteamUser',
                Organizations: 'OrganizationController/Organizations',
                RoleItems: 'RoleController/RoleItems',
            })
        },
        methods:{
            convertNewLine(str){
                return str.replace(/\n/g, '<br />');
            },
            setData(data) {
                if(data != null) {
                    this.user.id = data.id
                    this.user.name = data.name,
                    this.user.department = data.department,
                    this.user.designation = data.designation,
                    this.user.email = data.email,
                    this.user.organisation_id = data.organisation_id,
                    this.user.organization = data.organization;
                    this.user.role = data.roles;
                    this.user.active = data.active;
                    this.user.email_verified_at = data.email_verified_at;
                    this.user.preferred_contact_mode = data.preferred_contact_mode;
                    this.user.address = data.address;
                    this.user.password = '';
                    this.user.repassword = '';
                    this.user.mailing_address_id = data.mailing_address_id;
                    this.user.billing_address_id = data.billing_address_id;
                    this.user.property = data.property;
                    this.user.microsoft2fa_enable = data.microsoft2fa_enable;
                    this.user.active = !data.active;
                    if(data.id == '' || data.id == null) {
                        this.user.password = data.password
                        this.user.repassword = data.repassword
                    }
                    if(data.mailing_address_id){
                        this.user.mailing_address_id_tmp = data.address.findIndex(item => item.id === data.mailing_address_id)
                    }
                    if(data.billing_address_id){
                        this.user.billing_address_id_tmp = data.address.findIndex(item => item.id === data.billing_address_id)
                    }
                    if(data.tenant){
                        this.user.contract_id = data.tenant.client_contract_id;
                        this.user.property_id = data.tenant.property_id;
                    }

                    this.userDataRead = {
                        ...this.userDataRead,
                        ... {
                            login_count: data.login_count,
                            last_login: data.last_login,
                            created_at: data.created_at,
                            created_by_name: data.created_by && data.created_by.name && data.created_by.name ? data.created_by.name : null,
                            updated_at: data.updated_at,
                            updated_by_name: data.updated_by && data.updated_by.name && data.updated_by.name ? data.updated_by.name : null,
                        }
                    };

                    this.user.signature_image =  data.signature_image
                    this.user.gofix_projects =  data.gofix_projects
                    return;
                }
                this.user.password = ''
                this.user.repassword = ''
            },
            check_save() {
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.modals.restore_user_id = null;
                    this.$v.user.$touch();
                    if(this.$v.user.$error){
                        if(!this.user.email) return this.$alertNotification("Email is a required field.", "danger");
                        if(!this.user.gofix_projects || !this.user.gofix_projects.length) return this.$alertNotification("GOfix project is a required field.", "danger");
                        return this.$alertNotification("User is a required field.", "danger");
                    }
                    let params = {
                        email : this.user.email
                    }
                    this.$store.dispatch(`v2UserController/checkUser`, params)
                        .then(response => {
                            if(response.data == 0) {
                                this.save(1)
                            }
                            if(response.data == 1) {
                                return this.$alertNotification(response.message, "danger");
                            }
                            if(response.data == 2) {
                                this.modals.open = true
                                this.modals.restore_user_id = response.message.id
                            }
                        })
                        .catch(error => {})
                }, 300);
            },
            restore_user() {
                let params = {
                    id : this.modals.restore_user_id
                }
                this.$store.dispatch(`v2UserController/restoreUser`, params)
                    .then( async response => {
                        this.isAction = false;
                        this.$store.dispatch('v2UserController/getListUser', { page: this.Items.pages.page, filter: this.Items.pages.filter, limit: this.Items.pages.limit, isCMS: '1' })
                        this.modals.open = false
                        if(this.$route.path.includes('add')) {
                            this.$store.dispatch('v2UserController/getListUser', { page: this.Items.pages.page, filter: this.Items.pages.filter, limit: this.Items.pages.limit, isCMS: '1' })
                            await this.$router.push(`${this.$route.path.replace("add",this.modals.restore_user_id)}`)
                            //await  this.$router.push(`${this.$route.matched[this.$route.matched.length - 1].parent.path}/${this.modals.restore_user_id}`)
                        }
                        return await this.$alertNotification("Successfully recover user");
                    })
                    .catch(error => {})
            },
            save(check_save = 1) {
                if(check_save === 0) {
                    this.modals.open = false
                    return
                }
                
                if(this.userType === "tenant"){
                    //Check required mailing address
                    if(!this.user.address || this.user.mailing_address_id_tmp === null ||  this.user.mailing_address_id_tmp === false){
                        this.$alertNotification("Please add a mailing addess for tenant", "danger");
                        return;
                    }
                    //check required field in addesss
                    if(!this.user.address[this.user.mailing_address_id_tmp].salutation){
                        this.$alertNotification("Default mailing - Salutation is required", "danger");
                        return;
                    }
                    if(!this.user.address[this.user.mailing_address_id_tmp].first_name){
                        this.$alertNotification("Default mailing - First name is required", "danger");
                        return;
                    }
                    if(!this.user.address[this.user.mailing_address_id_tmp].last_name){
                        this.$alertNotification("Default mailing - Last name is required", "danger");
                        return;
                    }
                    if(!this.user.address[this.user.mailing_address_id_tmp].email){
                        this.$alertNotification("Default mailing - Email is required", "danger");
                        return;
                    }
                }

                if(!this.user.department){
                    this.$alertNotification("Department is required", "danger");
                    return;
                }
                
                if(check_save === 2) {
                    this.restore_user()
                    return
                }
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$v.user.$touch()
                    if(!this.$v.user.$error){
                        if(this.user.organization != null) {
                            this.user.organisation_id = this.user.organization.id;
                        }
                        if(this.user.property != null) {
                            this.user.property_id = this.user.property.id;
                        }
                        this.disabled = true
                        if(check_save === 3 && (this.user.id == 0 || this.user.id == '')) {
                            this.user.is_delete = true
                        }
                        let method = 'SaveUser'
                        let keyMessage= 'adding'
                        if(this.user.id != 0) {
                            method = 'updateUser'
                            keyMessage = 'editing'
                        }

                        let request = Object.assign({}, this.user);
                        request.active = !request.active;
                        if(request.mailing_address_id_tmp === false) {
                            request.mailing_address_id_tmp = '';
                        }

                        if(request.billing_address_id_tmp === false) {
                            request.billing_address_id_tmp = '';
                        }

                        request.attachment_id = null
                        request.attachment = this.attachmentFile
                        if(request.signature_image && request.signature_image[0] && request.signature_image[0].id) {
                            request.attachment_id = request.signature_image[0].id
                        }
                        
                        this.errorMessage = null;
                        this.$store.dispatch(`v2UserController/${method}`, request)
                            .then(async response => {
                                if(response.code == 400){
                                    if(response.data){
                                        this.errorMessage = this.convertNewLine(response.message);
                                        this.$bvToast.show('toast-custom1');
                                    }else{  
                                        this.$alertNotification(response.message, "danger");
                                    }
                                    this.disabled = false;
                                    return;
                                }
                                this.user.id = response.id;
                                this.disabled = false
                                this.modals.open = false
                                if(this.$route.path.includes('add')) {
                                    this.$router.push(`${this.$route.path.replace("add",response.id)}`)
                                }
                                await this.$alertNotification(this.$notificationV2(keyMessage, 'user'));
                            })
                            .catch(error => {
                                this.disabled = false
                                this.modals.open = false
                                if(error.error.message.password) {
                                    this.$alertNotification(error.error.message.password[0], "danger");
                                }
                                if(error.error.message.email) {
                                    this.$alertNotification(error.error.message.email[0], "danger");
                                }
                            })
                    } else {
                        if(!this.user.gofix_projects || !this.user.gofix_projects.length) return this.$alertNotification("GOfix project is a required field.", "danger");
                    }
                }, 300)
            },
            hanldeAddress() {
                this.activeAddress.display_address = generalAddressFormat(this.activeAddress)
                //this.user.address[this.activeAddress.key] = this.activeAddress.data;
                this.$refs['modal-address'].hide()
            },
            async searchOrganization(search, loading) {
                this.organizations = []
                if(!this.setValue) {
                    this.setValue = true
                }
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch('OrganizationController/searchItemsInUser', { filter: { name: search }, limit: 1000 })
                        .then(response => {
                            this.organizations = response.data.data.items
                            loading(false);
                        })
                        .catch(err => {
                            loading(false);
                        })
                }, 500);
            },
            addUserAddress(){
                this.user.address.push({
                    building_name: '',
                    city: null,
                    contact_name: null,
                    country: "Singapore",
                    display_address: "",
                    display_name: "",
                    email: null,
                    email_verified: false,
                    first_name: null,
                    full_address: "",
                    geo_location: null,
                    id: null,
                    last_name: null,
                    phone_verified: false,
                    postal_code: "",
                    primary_phone: "",
                    salutation: null,
                    secondary_phone: null,
                    street_name: "",
                    street_no: "",
                    unit_no: ""
                });
            },
            removeUserAddress(index){
                this.user.address.splice(index, 1);
                if(this.user.mailing_address_id_tmp && index <= this.user.mailing_address_id_tmp){
                    if(index < this.user.mailing_address_id_tmp){
                        this.user.mailing_address_id_tmp = this.user.mailing_address_id_tmp - 1;
                    }else{
                        this.user.mailing_address_id_tmp = null;
                    }

                }
                if(this.user.billing_address_id_tmp && index <= this.user.billing_address_id_tmp){
                    if(index < this.user.billing_address_id_tmp){
                        this.user.billing_address_id_tmp = this.user.billing_address_id_tmp - 1;
                    }else{
                        this.user.billing_address_id_tmp = null;
                    }
                }
            },
            openAddressModal(address,index){
                this.activeAddress = address;
                this.activeAddress.key = index;
                this.$refs['modal-address'].show()
            },
            setUserType(){
                if(this.$route.path.includes('tenant')){
                    this.userType = "tenant";
                    //Get contracts
                    this.getClientContract();
                }
            },
            getClientContract(){
                this.$store.dispatch('ContractController/getList', {
                    limit  : -1,
                    page   :  1
                })
                    .then(response => {
                        this.client_contracts = response.data.data.contracts
                    }).
                    catch(err => {
                        console.log(err);
                        this.client_contracts = [];
                });
            },
            getSalutations(){
                let filter = {reference_type: "Salutation"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.salutations = response.items;
                    })
            },
            getPreferredMode(){
                let filter = {reference_type: "Preferred Mode of Contact"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.preferred_mode = response.items;
                    })
            },
            async loadLoginHistories(){
              if(!this.$route.params.user_id) return;
              let tableRequest = {
                limit: 10,
                page: 1,
                isCMS: 1,
                sortColumn: "created_at",
                sortDirection: "DESC",
                filter: {
                  user_id: {
                    type: "number",
                    value: this.$route.params.user_id,
                    function: "=",
                    with: []
                  }
                }
              }
              this.modals.last_login.loading = true;
              await this.$store.dispatch("AuditTrailController/getUserActivityLogs", tableRequest)
                  .then(response => {
                    this.login_histories = response.items;
                    this.tableConfig.total = response.total;
                    this.modals.last_login.loading = false;
                  })
                  .catch(err => {
                    this.modals.last_login.loading = false;
                  })
            },
            getPreferredGofixProjects(){
                let filter = {reference_type: "GOfix Project"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.gofixProjects = response.items;
                    })
            },
        }
    }
</script>
<style>
    .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before{
        background-color: #F05600 !important;
    }
</style>